import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Supplier } from '../classes/supplier';
import config from "../config.json";

@Injectable({
    providedIn: 'root'
})
export class SupplierService {
    API_SUPPLIER_URL = config.serverAddress + ':' + config.serverPort + '/supplier/';

    constructor(private http: HttpClient) { }
    getAll() {
        return this.http.get<Array<Supplier>>(this.API_SUPPLIER_URL + 'all');
    }
    getByID(id: string | null) {
        return this.http.get<Supplier>(this.API_SUPPLIER_URL + id);
    }
    create(supplier: Supplier, foreignSupplier: boolean) {
        return this.http.post<Supplier>(this.API_SUPPLIER_URL + 'create', { ...supplier, foreign: foreignSupplier });
    }
    update(supplier: Supplier, foreignSupplier: boolean) {
        return this.http.put<Supplier>(this.API_SUPPLIER_URL + 'update', { ...supplier, foreign: foreignSupplier });
    }
    delete(id: number | undefined) {
        return this.http.delete(this.API_SUPPLIER_URL + 'delete/' + id);
    }
}
